import { useInfiniteQuery } from '@tanstack/react-query'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

// Category chips for a gallery, read from the `filterOptions` the community-gallery
// endpoint returns with every page. Takes the same query options the gallery grid
// subscribes with, so this is a second observer on the one cached query: react-query
// dedupes the request and the chips never cost a fetch of their own. With
// `keepPreviousData` the current chips stay up while a filter change refetches.
function useGalleryCategories(queryOptions) {
  const { data } = useInfiniteQuery(queryOptions)

  return data?.pages?.[0]?.filterOptions?.visibleCategories ?? EMPTY_ARRAY
}

export default useGalleryCategories
